/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { DelegatedAccessExternalIdsInner } from './DelegatedAccessExternalIdsInner';
import { DelegatedAccessExternalIdsInnerFromJSON, DelegatedAccessExternalIdsInnerFromJSONTyped, DelegatedAccessExternalIdsInnerToJSON, } from './DelegatedAccessExternalIdsInner';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DelegatedAccessExternalIds
 *
 */
// create custom validators for the regexes
export interface DelegatedAccessExternalIds extends Array<DelegatedAccessExternalIdsInner> {
}
/**
 * Check if a given object implements the DelegatedAccessExternalIds interface.
 */
export function instanceOfDelegatedAccessExternalIds(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { DelegatedAccessExternalIdsInnerValidator, DelegatedAccessExternalIdsInnerStringifyShape, DelegatedAccessExternalIdsInnerStringifyShapeProperties, } from './DelegatedAccessExternalIdsInner';
export const DelegatedAccessExternalIdsTypiaAssertEquals = (input: any) => {
    return ((input: any): DelegatedAccessExternalIds => {
        const __is = (input: any, _exceptionable: boolean = true): input is DelegatedAccessExternalIds => {
            const $join = (typia.createAssertEquals as any).join;
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $io1(value, true && _exceptionable);
                return false;
            });
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.externalId && 10 <= input.externalId.length && $is_custom("pattern_DelegatedAccessExternalIdsInner_externalId", "string", "", input.externalId) && (undefined === input.userId || "string" === typeof input.userId) && (undefined === input.teamId || "string" === typeof input.teamId) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["externalId", "userId", "teamId"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DelegatedAccessExternalIds => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DelegatedAccessExternalIdsInner",
                            value: value
                        })) && $ao1(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DelegatedAccessExternalIdsInner",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.externalId && (10 <= input.externalId.length || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string (@minLength 10)",
                    value: input.externalId
                })) && ($is_custom("pattern_DelegatedAccessExternalIdsInner_externalId", "string", "", input.externalId) || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string (@pattern_DelegatedAccessExternalIdsInner_externalId)",
                    value: input.externalId
                })) || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string",
                    value: input.externalId
                })) && (undefined === input.userId || "string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "(string | undefined)",
                    value: input.userId
                })) && (undefined === input.teamId || "string" === typeof input.teamId || $guard(_exceptionable, {
                    path: _path + ".teamId",
                    expected: "(string | undefined)",
                    value: input.teamId
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["externalId", "userId", "teamId"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DelegatedAccessExternalIds",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DelegatedAccessExternalIds",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DelegatedAccessExternalIdsTypiaAssertStringify = (input: DelegatedAccessExternalIds): string => {
    return ((input: any): string => { const assert = (input: any): DelegatedAccessExternalIds => {
        const __is = (input: any): input is DelegatedAccessExternalIds => {
            const $join = (typia.createAssertStringify as any).join;
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $io0 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "object" === typeof value && null !== value && $io1(value);
                return true;
            });
            const $io1 = (input: any): boolean => "string" === typeof input.externalId && 10 <= input.externalId.length && $is_custom("pattern_DelegatedAccessExternalIdsInner_externalId", "string", "", input.externalId) && (undefined === input.userId || "string" === typeof input.userId) && (undefined === input.teamId || "string" === typeof input.teamId);
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DelegatedAccessExternalIds => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return ("object" === typeof value && null !== value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DelegatedAccessExternalIdsInner",
                            value: value
                        })) && $ao1(value, _path + $join(key), true && _exceptionable) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "DelegatedAccessExternalIdsInner",
                            value: value
                        });
                    return true;
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.externalId && (10 <= input.externalId.length || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string (@minLength 10)",
                    value: input.externalId
                })) && ($is_custom("pattern_DelegatedAccessExternalIdsInner_externalId", "string", "", input.externalId) || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string (@pattern_DelegatedAccessExternalIdsInner_externalId)",
                    value: input.externalId
                })) || $guard(_exceptionable, {
                    path: _path + ".externalId",
                    expected: "string",
                    value: input.externalId
                })) && (undefined === input.userId || "string" === typeof input.userId || $guard(_exceptionable, {
                    path: _path + ".userId",
                    expected: "(string | undefined)",
                    value: input.userId
                })) && (undefined === input.teamId || "string" === typeof input.teamId || $guard(_exceptionable, {
                    path: _path + ".teamId",
                    expected: "(string | undefined)",
                    value: input.teamId
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DelegatedAccessExternalIds",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DelegatedAccessExternalIds",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DelegatedAccessExternalIds): string => {
        const $io1 = (input: any): boolean => "string" === typeof input.externalId && 10 <= input.externalId.length && $is_custom("pattern_DelegatedAccessExternalIdsInner_externalId", "string", "", input.externalId) && (undefined === input.userId || "string" === typeof input.userId) && (undefined === input.teamId || "string" === typeof input.teamId);
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${$so1(value)}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        const $so1 = (input: any): any => `{${undefined === input.userId ? "" : `"userId":${undefined !== input.userId ? $string(input.userId) : undefined},`}${undefined === input.teamId ? "" : `"teamId":${undefined !== input.teamId ? $string(input.teamId) : undefined},`}"externalId":${$string(input.externalId)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const DelegatedAccessExternalIdsValidatorShape = {};
export const DelegatedAccessExternalIdsValidator = yup.array().of(DelegatedAccessExternalIdsInnerValidator);
export const DelegatedAccessExternalIdsStringifyShapeProperties: ObjectSchema['properties'] = {};
export const DelegatedAccessExternalIdsStringifyShape: ArraySchema = {
    title: 'DelegatedAccessExternalIds Stringifier',
    type: 'array',
    items: DelegatedAccessExternalIdsInnerStringifyShape
};
export const DelegatedAccessExternalIdsStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DelegatedAccessExternalIdsStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DelegatedAccessExternalIdsStringify: (data: DelegatedAccessExternalIds) => string = DelegatedAccessExternalIdsStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DelegatedAccessExternalIdsFromJSON(json: any): DelegatedAccessExternalIds {
    return DelegatedAccessExternalIdsFromJSONTyped(json, false);
}
export function DelegatedAccessExternalIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegatedAccessExternalIds {
    return json;
}
export function DelegatedAccessExternalIdsToJSON(value?: DelegatedAccessExternalIds | null): any {
    return value;
}
